
import { Component, Vue, Prop } from 'vue-property-decorator';
import { HistoryData } from '@/types/history';
import MapControl from '@/components/MapControl.vue';

@Component({
    components: {
        MapControl,
    },
})
export default class DeviceMap extends Vue {
    @Prop({ required: true, default: [] })
    locations!: HistoryData[];
}
